import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { setUpdate } from '../../../../store/reducers/app/ThemeSlice'
import { setSystemData } from '../../../../hooks/systemData'
import { ISwitch } from '../../../../models/ISwitch'
import { Strings } from '../../../../constants/Strings'
import { Colors } from '../../../../constants/Colors'
import style from './Theme.module.css'
import Switches from '../../../widgets/Switches/Switches'

const Theme = () => {

    const dispatch = useAppDispatch()

    const theme = useAppSelector<string>(state => state.theme.theme)
    const themeId = useAppSelector<string>(state => state.theme.themeId)
    const language = useAppSelector<string>(state => state.language.language)

    const themes = [
        {id: 1, title: Strings[language ?? 'tm'].light, value: 'light'},
        {id: 2, title: Strings[language ?? 'tm'].dark, value: 'dark'}
    ]

    const themeIndex = themes.find(
        ({id, value}) => id === parseInt(themeId) && value === theme
    )

    const [selectedTheme, setSelectedTheme] = useState<ISwitch>(
        themeIndex ? themeIndex : {id: 1, title: Strings[language ?? 'tm'].light, value: 'light'}
    )

    useEffect(() => {
        setSystemData('theme', selectedTheme.value)
        setSystemData('themeId', selectedTheme.id.toString())
        dispatch(setUpdate(true))
    }, [selectedTheme])

    return (
        <div
            className={style.container}
        >
            <span
                className={style.icon}
                style={{
                    color: Colors[theme ?? 'light'].text
                }}
            >
                <i className="fas fa-circle"></i>
            </span>
            <span
                className={style.title}
                style={{
                    color: Colors[theme ?? 'light'].text
                }}
            >
                {Strings[language ?? 'tm'].theme}:
            </span>
            <div
                className={style.switchContainer}
            >
                <Switches
                    containerWidth={280}
                    containerHeight={40}
                    activeTextColor={Colors[theme ?? 'light'].white}
                    inActiveTextColor={Colors[theme ?? 'light'].text}
                    borderColor={Colors[theme ?? 'light'].app}
                    buttonBackgroundColor={Colors[theme ?? 'light'].secondBackground}
                    switchBackgroundColor={Colors[theme ?? 'light'].app}
                    switches={themes}
                    selectedSwitch={selectedTheme}
                    setSelectedSwitch={setSelectedTheme}
                />
            </div>
        </div>
    )
}

export default Theme